<template>
  
  <div id="app_content" class="admin settings">

    <h1 class="mt-0">Impostazioni B2B</h1>

    <div class="options" v-if="options && options.length > 0">

      <div v-for="option in options" :key="option.id" class="option">

          <h3 class="m-0">{{getOptionTitle(option)}}</h3>

          <span v-if="getOptionDescription(option)" v-html="getOptionDescription(option)"></span>

          <div class="action">

          <input v-model="option.valore">

          <button name="update-option" class="animated" @click="updateOption(option.nome, option.valore, $event)">Aggiorna</button>

        </div>

      </div>

    </div>

    <p v-else class="empty">Nessuna impostazione trovata...</p>

  </div>

</template>

<script>
export default{

  data: function(){

    return {
      options: [],
      labels: [
        {
          option: 'admin_email',
          text: 'Email di amministrazione'
        },
        {
          option: 'payoff',
          text: 'Slogan della piattaforma'
        },
        {
          option: 'ig_token',
          text: 'Token gallery instagram'
        }       
      ],
      instructions: [
        {
          option: 'admin_email',
          text: 'Inserisci qui gli indirizzi email (separati da virgola) che dovranno ricevere le comunicazioni dal B2B.'
        },
        {
          option: 'ig_token',
          text: 'Inserisci qui il token che verrà utilizzato dall\'app "basic display" di facebook per ottenere le informazioni dell\'account instagram.<br>Il token verrà rinnovato ogni 7 giorni.'
        }
      ],
      loading: false,
    }

  },

  methods: {

    getOptionTitle(option){

      return _.find(this.labels, function(label){ return label.option == option.nome; })
        ? _.find(this.labels, function(label){ return label.option == option.nome; }).text
        : null;

    },

    getOptionDescription(option){

      return _.find(this.instructions, function(instruction){ return instruction.option == option.nome; })
        ? _.find(this.instructions, function(instruction){ return instruction.option == option.nome; }).text
        : null;

    },

    /**
     * Load options
     */
    loadOptions: function(){

      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + '/data/get-options',
      })
      .then(res => {

        vue.options = res.data.options ? res.data.options : [];

      })
      .catch(err => {

        console.log(err)

        vue.$store.commit('add_message', {
          'type': 'error',
          'message': err
        });

      })
      .then( () => {
        vue.loading = false;
      })

    },

    /**
     * Update options
     */
    updateOption: function(name, value, event){

      var vue = this;

      if( event.target.classList.contains('loading') ) return;

      event.target.classList.add('loading');

      axios({
        method: "post",
        url: window.location.origin + '/data/update-option',
        data: {
          name: name,
          value: value
        }
      })
      .then(res => {
        
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

      })
      .catch(err => {

        console.log(err);
        
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });

      })
      .then(() =>{
        event.target.classList.remove('loading');
      })

    }

  },

  mounted: function(){
    this.loadOptions();
  }

}
</script>

<style scoped>
.option{
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  margin-top: 2em;
}
.option .action{
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 10px;
}
.option .action input{
  width: calc(100% - 150px);
}
.option .action button{
  width: 150px;
  text-align:center;
  color: white;
  background-color: var(--black);
  border: 1px solid var(--black);
}
.option .action button:hover{
  color: var(--black);
  background-color: white;
}
.option .action button,
.option .action input{
	line-height: 1em;
	font-size: 1em;
	height: 36px;
	padding: 0 10px;
}
.option .action button.loading,
.option .action button.loading:hover{
  color: var(--black);
  background-color: var(--black);
}
</style>